import React from 'react';


const ManualPage = () => {
	return <div className={"animated fadeIn container"}>
        <ul>
            <li><a href={"/manual/MANUALE MAGICO_V3.pdf"} download>Manuale piattaforma MAGICO</a></li>
            <li><a href={"/manual/TABELLA SERVIZI DISPONIBILI CON AGRISMART.pdf"} download>Tabella servizi AGRISMART</a></li>
        </ul>
    </div>;
};

export default ManualPage;